;(function() {
  'use strict'

  angular.module('core.question-templates-picker', [])
})()
